import { CountUp } from 'countup.js';
import InViewport from 'in-viewport';

const countUpOptions = {
  duration: 2,
  startVal: 0,
  useEasing: true,
};

const viewportOptions = {
  offset: -100,
};

export default class Stats {
  constructor(element) {
    this.element = element;
    this.countupOptions = countUpOptions;
    this.viewportOptions = viewportOptions;
    this.listen();
  }

  visibleHandler() {
    this.slides.forEach((slide) => {
      const value = slide.querySelector('.value');
      const digits = document.createElement('span');
      digits.className = 'digits';
      digits.innerText = '0';

      if (value) {
        const html = value.cloneNode();
        const exp = new RegExp(/([0-9.,]{2,})/);
        const results = value.innerHTML.split(exp);
        results.forEach((result, i) => {
          let output = document.createTextNode(result);
          if (i === 1) {
            digits.setAttribute('data-end', result.replace(/[.,]/, ''));
            output = digits;
          }
          html.appendChild(output);
        });
        value.replaceWith(html);
        this.startCountDown(digits);
      }
    });
  }

  startCountDown(element) {
    const endValue = Number(element.getAttribute('data-end'));
    element.countUp = new CountUp(element, endValue, this.countUpOptions);
    element.countUp.start();
  }

  listen() {
    InViewport(this.element, this.viewportOptions, this.visibleHandler.bind(this));
  }

  get slides() {
    return this.element.querySelectorAll('.block-content > *');
  }
}
